export default "<h1>Type6Date list</h1>\n<spec-app-type6-date-table [clickHandler]=\"createClickHandler()\"></spec-app-type6-date-table>";